import type { DependentFlagByEnvCollection, DependentFlagCollection } from '#utils/flags/records/DependentFlags';

export type FlagAndEnvKeys = Record<
  string,
  Array<{ flagKey: string; archived?: boolean; archivedDate?: number; env: string; selfLink: string }>
>;

export function groupDependentFlagsByEnv(props: DependentFlagByEnvCollection, env?: string) {
  const flagsWithDependents: FlagAndEnvKeys = {};
  if (env) {
    props.items.forEach((dependentFlag) => {
      const dependentFlagKey = dependentFlag.get('key');
      flagsWithDependents[dependentFlagKey] = [
        {
          flagKey: dependentFlag.get('key'),
          archived: dependentFlag.get('archived'),
          archivedDate: dependentFlag.get('archivedDate'),
          env,
          selfLink: dependentFlag.getIn(['_site', 'href']),
        },
      ];
    });
  }
  return flagsWithDependents;
}

export function groupDependentFlags(props: DependentFlagCollection) {
  const flagsWithDependents: FlagAndEnvKeys = {};
  props.items.forEach((dependentFlag) => {
    const dependentFlagKey = dependentFlag.get('key');
    flagsWithDependents[dependentFlagKey] = [];
    const envs = dependentFlag.get('environments').map((environment) => ({
      flagKey: dependentFlag.get('key'),
      archived: dependentFlag.get('archived'),
      archivedDate: dependentFlag.get('archivedDate'),
      env: environment.get('key'),
      selfLink: environment.getIn(['_site', 'href']),
    }));
    flagsWithDependents[dependentFlagKey] = envs.toArray();
  });
  return flagsWithDependents;
}
